<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import CggscxBrowse from "./CggscxBrowse";
import CggscxView from "./CggscxView";
export default {
    name: "Cggscx",
    components: { CggscxBrowse, CggscxView },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showView: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showView === true) {
                return "CggscxView";
            } else {
                return "CggscxBrowse";
            }
        }
    }
};
</script>
